import { setToken } from '../../api.ts';
import { h } from '../../ui.ts';
import { icon, screen } from './kit.ts';

/** Sign in on the phone: the daemon token, once. */
export function phoneLogin(): HTMLElement {
  const input = h('input', {
    class: 'input p-input',
    type: 'password',
    placeholder: 'Token',
    'aria-label': 'Daemon token',
    autocomplete: 'current-password',
  });
  const go = () => {
    setToken(input.value.trim());
    location.reload();
  };
  input.addEventListener('keydown', (e) => (e as KeyboardEvent).key === 'Enter' && go());
  return screen(
    h('span', { class: 'p-brand' }, h('span', { class: 'brand-mark' }, icon.mark(14)), 'Assistant'),
    h(
      'div',
      { class: 'p-login' },
      h('h1', { class: 'p-title' }, 'Sign in', h('br'), h('span', {}, 'with your daemon token.')),
      input,
      h('button', { class: 'p-primary', onclick: go }, 'Continue'),
    ),
  );
}
